import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import ClientSidebar from "./ClientSidebar";
import MobileNavSelect from "./MobileNavSelect";

interface SidebarContainerProps {
  children: React.ReactNode;
}

export const SidebarContainer: React.FC<SidebarContainerProps> = ({
  children,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const update = () => {
      const top = container.getBoundingClientRect().top;
      const safeTop = Math.max(0, top);
      container.style.height = `calc(100vh - ${safeTop}px)`;
    };

    const ro = new ResizeObserver(update);
    ro.observe(container);
    window.addEventListener("resize", update);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <Box
      ref={containerRef}
      sx={{ display: "flex", overflow: "hidden", marginTop: { xs: 0, md: "24px" }, px: "24px" }}
    >
      {!isMobile && <ClientSidebar />}
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto", minHeight: 0, paddingBottom: "24px" }}>
        {isMobile && (
          <Box
            sx={{
              p: "24px 16px",
              backgroundColor: "background.paper",
              position: "sticky",
              top: 0,
              zIndex: 1000,
            }}
          >
            <MobileNavSelect />
          </Box>
        )}
        {children}
      </Box>
    </Box>
  );
};

export default SidebarContainer;
